import React from "react";
import { FaCode, FaShieldAlt, FaVial, FaCogs } from "react-icons/fa";

function CodeReview() {
  return (
    <>
      <div className="services-style-two-area default-padding">
        <div className="shape">
          <img
            src="assets/img/thumb/ai_optimized_img.png"
            alt="Image Not Found"
          />
        </div>
        <div className="container">
          <div className="row">
            <div className="col-xl-8 offset-xl-4 col-lg-8">
              <div className="site-heading">
                <h4 className="sub-title">Our Services</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Xeer Technology’s Smart Contract Audit Process
                </h2>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row">
            <div className="col-xl-8 offset-xl-4">
              <div className="services-style-four-items">

                {/* Code Review */}
                <div className="services-style-four-item">
                  <div className="icon">
                    <FaCode style={{ fontSize: "40px", color: "#0155FF" }} />
                  </div>
                  <h4>Code Review</h4>
                  <p>
                    We conduct a thorough manual and automated review of your
                    code to identify potential vulnerabilities and ensure
                    high-quality code standards.
                  </p>
                </div>

                {/* Security Analysis */}
                <div className="services-style-four-item">
                  <div className="icon">
                    <FaShieldAlt style={{ fontSize: "40px", color: "#F7931A" }} />
                  </div>
                  <h4>Security Analysis</h4>
                  <p>
                    Our team examines your contract for security risks,
                    including reentrancy attacks, overflow vulnerabilities, and
                    unauthorized access points, providing a clear roadmap for
                    remediation.
                  </p>
                </div>

                {/* Functional Testing */}
                <div className="services-style-four-item">
                  <div className="icon">
                    <FaVial style={{ fontSize: "40px", color: "#8247E5" }} />
                  </div>
                  <h4>Functional Testing</h4>
                  <p>
                    Through comprehensive functional testing, we evaluate your
                    contract’s performance in different scenarios, ensuring that
                    it operates as intended under all conditions.
                  </p>
                </div>

                {/* Optimization */}
                <div className="services-style-four-item">
                  <div className="icon">
                    <FaCogs style={{ fontSize: "40px", color: "#14F195" }} />
                  </div>
                  <h4>Optimization Recommendations</h4>
                  <p>
                    Our audit includes recommendations to improve contract
                    efficiency, helping to minimize gas costs and optimize
                    performance.
                  </p>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CodeReview;